import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { tr } from 'date-fns/locale';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { compareDates, getDateFormat } from '../../_helpers/useful-functions';
import { IFilterDatepicker } from '../../models/moments-report/filter-datepicker';
import { useAppSelector } from '../../store';
import { setReportFilter } from '../../store/features/moments-reports/momentReportsSlice';

const FilterDatepicker = ({ type, isTouched }: IFilterDatepicker) => {
    // const [selectedDate, setSelectedDate] = useState({ startDate: new Date(new Date().setDate(new Date().getDate() - 30)), endDate: new Date() });
    const [isDatePickerOpen, setIsDatePickerOpen] = useState<boolean>(false);
    const dispatch = useDispatch();
    const { reportFilter } = useAppSelector(state => state.momentReports);

    const placeholderText = type === 'start' ? 'Başlangıç tarihi' : type === 'end' ? 'Bitiş tarihi' : '';

    const handleDateChange = (date: Date | null) => {
        if (type === 'start') {
            const newStartDate = date;
            let newEndDate = reportFilter?.endDate;

            if (newStartDate && newEndDate) {
                const oneYearAfterStartDate = new Date(newStartDate);
                oneYearAfterStartDate.setFullYear(oneYearAfterStartDate.getFullYear() + 1);

                if (oneYearAfterStartDate < newEndDate || (oneYearAfterStartDate.getFullYear() - newEndDate.getFullYear()) > 1) {
                    newEndDate = oneYearAfterStartDate;
                }
            }

            dispatch(
                setReportFilter({
                    ...reportFilter,
                    startDate: newStartDate,
                    endDate: newEndDate,
                }),
            );
        } else if (type === 'end') {
            // setSelectedDate({ ...selectedDate, endDate: date });

            dispatch(
                setReportFilter({
                    ...reportFilter,
                    endDate: date,
                }),
            );
        }
    };

    const validateMessage =
        type === 'start' &&
            (new Date(reportFilter?.startDate).toDateString() === 'Invalid Date' || getDateFormat({ date_: reportFilter?.startDate }) === 'Invalid Date')
            ? 'Tarih formatını gün/ay/yıl olarak giriniz'
            : type === 'end' &&
                (new Date(reportFilter?.endDate).toDateString() === 'Invalid Date' ||
                    getDateFormat({ date_: reportFilter?.endDate }) === 'Invalid Date')
                ? 'Tarih formatını gün/ay/yıl olarak giriniz'
                : type === 'start' && new Date(reportFilter?.startDate) > new Date(reportFilter?.endDate)
                    ? ''
                    : type === 'end' && reportFilter?.endDate && compareDates({ firstDate: reportFilter?.startDate, secondDate: reportFilter?.endDate })
                        ? 'Bitiş Tarihi, Başlangıç tarihinden önce olamaz.'
                        : '';
    const oneYearFromStartDate = reportFilter?.startDate ? new Date(reportFilter?.startDate) : new Date();
    oneYearFromStartDate.setFullYear(oneYearFromStartDate.getFullYear() + 1);

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={tr}>
            <KeyboardDatePicker
                minDate={
                    type === 'end' && reportFilter?.startDate
                        ? new Date(reportFilter?.startDate)
                        : type === 'start'
                            ? new Date().setFullYear(new Date().getFullYear() - 2)
                            : null
                }
                maxDate={
                    type === 'start' && reportFilter?.endDate
                        ? new Date(reportFilter?.endDate)
                        : type === 'end'
                            ? oneYearFromStartDate
                            : null
                }
                onClick={() => setIsDatePickerOpen(true)}
                // helperText={<TextField>{validateMessage}</TextField>}
                helperText={validateMessage}
                onClose={() => setIsDatePickerOpen(false)}
                open={isDatePickerOpen}
                className={
                    (type === 'end' &&
                        (compareDates({ firstDate: reportFilter?.startDate, secondDate: reportFilter?.endDate }) ||
                            (!reportFilter?.endDate && reportFilter?.startDate))) ||
                        (type === 'start' && reportFilter?.endDate && !reportFilter?.startDate)
                        ? 'datepicker-04 error'
                        : 'datepicker-04'
                }
                disableToolbar
                autoOk
                placeholder={placeholderText}
                variant="inline"
                inputVariant="outlined"
                format="dd/MM/yyyy"
                id="date-picker-inline"
                value={type === 'start' ? reportFilter?.startDate : type === 'end' ? reportFilter?.endDate : null}
                onChange={handleDateChange}
                KeyboardButtonProps={{
                    'aria-label': 'change date',
                }}
                PopoverProps={{
                    anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                    transformOrigin: { horizontal: 'left', vertical: 'top' },
                    id: 'report-datepicker' + (type === 'start' ? '-start' : type === 'end' ? '-end' : ''),
                    className: 'report-datepicker-04' + (type === 'start' ? '-start' : type === 'end' ? '-end' : ''),
                }}
            />
        </MuiPickersUtilsProvider>
    );
};

export default FilterDatepicker;
